<div class="modal-content">
  <div class="modal-body text-center modal-aviso-cpf-invalido__body">
    <section class="modal-aviso-cpf-invalido__content">
      <img src="assets/images/verify_invalid_cpf_user.svg" alt="videocam" />
    </section>
    <div class="modal-aviso-cpf-invalido__subtitle">{{ message }}</div>
  </div>

  <div class="modal-footer modal-aviso-cpf-invalido__action">
    <app-gradient-button label="Continuar" (click)="close()">
    </app-gradient-button>
  </div>
</div>
